import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { RejectPartItem, RejectPartResult } from '../../../models/part-reject.modal';

@Component({
  selector: 'app-reject-part',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgbModule, TranslocoDirective, TranslocoPipe],
  templateUrl: './reject-part.component.html',
  styleUrl: './reject-part.component.scss'
})
export class RejectPartComponent {
  @Input() workOrderNumber: string = '';
  @Input() parts: RejectPartItem[] = [];
  @Input() onSave!: (result: RejectPartResult) => Promise<void>;

  form: FormGroup;
  isLoading = false;

  private activeModal = inject(NgbActiveModal);
  private fb = inject(FormBuilder);
  private transloco = inject(TranslocoService);

  constructor() {
    this.form = this.fb.group({
      note: ['']
    });
  }

  get isBulk(): boolean {
    return this.parts.length > 1;
  }

  get title(): string {
    return this.transloco.translate(
      this.isBulk ? 'parts.modals.rejectPart.bulkTitle' : 'parts.modals.rejectPart.title'
    );
  }

  get singlePart(): RejectPartItem | null {
    return !this.isBulk && this.parts.length === 1 ? this.parts[0] : null;
  }

  onCancel(): void {
    this.activeModal.dismiss();
  }

  async onSubmit(): Promise<void> {
    if (this.form.invalid || this.isLoading) return;

    const result: RejectPartResult = {
      note: this.form.get('note')?.value?.trim() || null
    };

    this.isLoading = true;
    try {
      await this.onSave(result);
      this.activeModal.close();
    } catch {
      this.isLoading = false;
    }
  }
}
